<template>
  <!-- Adresse de livraison -->
  <div
    v-if="panel === 'livraison'"
    class="order-admin-zone__panel border border-yellow-300 rounded overflow-hidden bg-white min-w-0 w-full"
  >
      <div
        class="order-admin-zone__heading flex items-center gap-2 px-3 py-2 bg-[#fcf8e3] border-b border-yellow-300"
      >
        <span class="font-semibold text-[#8a6d3b]">Admin</span>
        <span class="text-sm font-medium text-[#8a6d3b]">Adresse de livraison</span>
      </div>
    <table class="w-full text-sm">
      <tbody>
        <tr class="border-b border-gray-200">
          <td class="px-3 py-2 font-medium w-2/5 align-top">
            {{ livraisonEnseigneLabel }}
          </td>
          <td class="px-3 py-2">
            <input
              v-model="form.liv.societe"
              type="text"
              class="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
            />
          </td>
        </tr>
        <tr v-if="showLivraisonContact" class="border-b border-gray-200">
          <td class="px-3 py-2 font-medium align-top">Nom du contact</td>
          <td class="px-3 py-2">
            <input
              v-model="form.liv.contact"
              type="text"
              class="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
            />
          </td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-3 py-2 font-medium align-top">Adresse</td>
          <td class="px-3 py-2">
            <input
              v-model="form.liv.adresse"
              type="text"
              class="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
            />
          </td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-3 py-2 font-medium align-top">Code postal</td>
          <td class="px-3 py-2">
            <input
              v-model="form.liv.codePostal"
              type="text"
              class="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
            />
          </td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-3 py-2 font-medium align-top">Ville</td>
          <td class="px-3 py-2">
            <input
              v-model="form.liv.ville"
              type="text"
              class="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
            />
          </td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-3 py-2 font-medium align-top">Pays</td>
          <td class="px-3 py-2">{{ livraisonPays }}</td>
        </tr>
        <tr>
          <td class="px-3 py-2 font-medium align-top">Téléphone</td>
          <td class="px-3 py-2">
            <input
              v-model="form.liv.telephone"
              type="text"
              class="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
            />
          </td>
        </tr>
        <tr>
          <td colspan="2" class="px-3 py-3">
            <button
              type="button"
              class="px-3 py-1.5 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
              :disabled="savingLivraison || !livraisonIdAdresse"
              @click="saveLivraison"
            >
              {{ savingLivraison ? "Enregistrement…" : "Enregistrer" }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Adresse de facturation -->
  <div
    v-else
    class="order-admin-zone__panel border border-yellow-300 rounded overflow-hidden bg-white min-w-0 w-full"
  >
      <div
        class="order-admin-zone__heading flex items-center gap-2 px-3 py-2 bg-[#fcf8e3] border-b border-yellow-300"
      >
        <span class="font-semibold text-[#8a6d3b]">Admin</span>
        <span class="text-sm font-medium text-[#8a6d3b]">Adresse de facturation</span>
      </div>
    <table class="w-full text-sm">
      <tbody>
        <tr class="border-b border-gray-200">
          <td class="px-3 py-2 font-medium w-2/5 align-top">
            Nom de la société
          </td>
          <td class="px-3 py-2">
            <input
              v-model="form.fac.societe"
              type="text"
              class="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
            />
          </td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-3 py-2 font-medium align-top">Adresse</td>
          <td class="px-3 py-2">
            <input
              v-model="form.fac.adresse"
              type="text"
              class="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
            />
          </td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-3 py-2 font-medium align-top">Code postal</td>
          <td class="px-3 py-2">
            <input
              v-model="form.fac.codePostal"
              type="text"
              class="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
            />
          </td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-3 py-2 font-medium align-top">Ville</td>
          <td class="px-3 py-2">
            <input
              v-model="form.fac.ville"
              type="text"
              class="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
            />
          </td>
        </tr>
        <tr class="border-b border-gray-200">
          <td class="px-3 py-2 font-medium align-top">Pays</td>
          <td class="px-3 py-2">{{ facturationPays }}</td>
        </tr>
        <tr>
          <td class="px-3 py-2 font-medium align-top">Téléphone</td>
          <td class="px-3 py-2">
            <input
              v-model="form.fac.telephone"
              type="text"
              class="w-full border border-gray-300 rounded px-2 py-1 text-sm bg-white"
            />
          </td>
        </tr>
        <tr>
          <td colspan="2" class="px-3 py-3">
            <button
              type="button"
              class="px-3 py-1.5 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
              :disabled="savingFacturation || !facturationIdAdresse"
              @click="saveFacturation"
            >
              {{ savingFacturation ? "Enregistrement…" : "Enregistrer" }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, ref, watch } from "vue";
import { getApiBaseUrl } from "@/config/api";
import { useNotification } from "@/composables/useNotification";
import { getDomTomNameFromPostalCode } from "@/utils/domTom";
import type { OrderDetailResponse } from "@/types";

const props = defineProps<{
  orderDetail: OrderDetailResponse | null;
  panel: "livraison" | "facturation";
}>();

const { error: notifyError, success: notifySuccess } = useNotification();

const savingLivraison = ref(false);
const savingFacturation = ref(false);

const form = reactive({
  liv: {
    societe: "",
    contact: "",
    adresse: "",
    codePostal: "",
    ville: "",
    telephone: "",
  },
  fac: {
    societe: "",
    adresse: "",
    codePostal: "",
    ville: "",
    telephone: "",
  },
});

const livraison = computed(() => props.orderDetail?.adresseLivraison ?? null);
const facturation = computed(
  () => props.orderDetail?.adresseFacturation ?? null,
);
const acheteur = computed(() => props.orderDetail?.acheteur ?? null);

/** IDs BDD sur la commande (fiables même si l'adresse affichée vient du checkout). */
const livraisonIdAdresse = computed(
  () =>
    props.orderDetail?.id_adresse_livraison ??
    livraison.value?.id_adresse ??
    null,
);

const facturationIdAdresse = computed(
  () =>
    props.orderDetail?.id_adresse_facturation ??
    facturation.value?.id_adresse ??
    null,
);

const hasLivraisonSociete = computed(() =>
  Boolean(livraison.value?.Societe?.trim()),
);

const livraisonEnseigneLabel = computed(() =>
  hasLivraisonSociete.value ? "Nom de l'enseigne" : "Nom de la société",
);

const showLivraisonContact = computed(() =>
  Boolean(livraison.value?.NomContact?.trim()),
);

function formatCountry(
  country: { id_pays: number; texte_fr: string } | null | undefined,
  postalCode: string,
): string {
  const countryName = country?.texte_fr?.trim() ?? "";
  const normalizedCountry = countryName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
  const isFranceDomTom =
    country?.id_pays === 42 ||
    /france\s+dom[\s/-]*tom/.test(normalizedCountry);

  if (!isFranceDomTom) return countryName;

  const territory = getDomTomNameFromPostalCode(postalCode);

  return territory ? `${countryName} (${territory})` : countryName;
}

const livraisonPays = computed(() =>
  formatCountry(livraison.value?.pays, form.liv.codePostal),
);
const facturationPays = computed(() =>
  formatCountry(facturation.value?.pays, form.fac.codePostal),
);

function syncFormFromOrder() {
  const d = props.orderDetail;
  if (!d) return;

  form.liv.societe =
    livraison.value?.Societe?.trim() || acheteur.value?.nomSociete || "";
  form.liv.contact = livraison.value?.NomContact?.trim() || "";
  form.liv.adresse = livraison.value?.adresse ?? "";
  form.liv.codePostal = livraison.value?.codePostal ?? "";
  form.liv.ville = livraison.value?.ville ?? "";
  form.liv.telephone =
    livraison.value?.telephone || livraison.value?.mobile || "";

  form.fac.societe =
    facturation.value?.Societe?.trim() || acheteur.value?.nomSociete || "";
  form.fac.adresse = facturation.value?.adresse ?? "";
  form.fac.codePostal = facturation.value?.codePostal ?? "";
  form.fac.ville = facturation.value?.ville ?? "";
  form.fac.telephone =
    facturation.value?.telephone || facturation.value?.mobile || "";
}

watch(() => props.orderDetail, syncFormFromOrder, {
  immediate: true,
  deep: true,
});

async function saveAdresse(
  name: string,
  value: string,
  idAdresse: number | null,
): Promise<boolean> {
  if (!idAdresse) {
    notifyError("Adresse introuvable — enregistrement impossible");
    return false;
  }
  try {
    const response = await fetch(
      `${getApiBaseUrl()}/api/admin-efp/groupages/save-adresse`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idAdresse, name, value }),
      },
    );
    if (!response.ok) {
      notifyError("Erreur lors de l'enregistrement de l'adresse");
      return false;
    }
    return true;
  } catch {
    notifyError("Erreur lors de l'enregistrement de l'adresse");
    return false;
  }
}

async function saveLivraison() {
  if (!livraisonIdAdresse.value || savingLivraison.value) return;

  savingLivraison.value = true;
  const id = livraisonIdAdresse.value;
  const fields: [string, string][] = [
    ["nomSociete_liv", form.liv.societe],
    ["adresse_liv", form.liv.adresse],
    ["codePostal_liv", form.liv.codePostal],
    ["ville_liv", form.liv.ville],
    ["telephone_liv", form.liv.telephone],
  ];
  if (showLivraisonContact.value) {
    fields.splice(1, 0, ["nomContact_liv", form.liv.contact]);
  }

  try {
    const results = await Promise.all(
      fields.map(([name, value]) => saveAdresse(name, value, id)),
    );
    if (results.every(Boolean)) {
      notifySuccess("Adresse de livraison enregistrée");
    }
  } finally {
    savingLivraison.value = false;
  }
}

async function saveFacturation() {
  if (!facturationIdAdresse.value || savingFacturation.value) return;

  savingFacturation.value = true;
  const id = facturationIdAdresse.value;
  const fields: [string, string][] = [
    ["nomSociete_fac", form.fac.societe],
    ["adresse_fac", form.fac.adresse],
    ["codePostal_fac", form.fac.codePostal],
    ["ville_fac", form.fac.ville],
    ["telephone_fac", form.fac.telephone],
  ];

  try {
    const results = await Promise.all(
      fields.map(([name, value]) => saveAdresse(name, value, id)),
    );
    if (results.every(Boolean)) {
      notifySuccess("Adresse de facturation enregistrée");
    }
  } finally {
    savingFacturation.value = false;
  }
}
</script>
